import { motion } from "framer-motion";

// Connective tissue between two homepage sections: a glowing gradient line
// with drifting particles, so scrolling from one section to the next never
// feels like a hard cut.
export const SectionDivider = () => (
  <div className="relative h-20 overflow-hidden sm:h-28" aria-hidden="true">
    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-primary/[0.05] to-transparent" />
    <motion.div
      initial={{ scaleX: 0, opacity: 0 }}
      whileInView={{ scaleX: 1, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
      className="animate-glow-sweep absolute left-1/2 top-1/2 h-px w-2/3 max-w-xl -translate-x-1/2 -translate-y-1/2"
      style={{
        backgroundImage:
          "linear-gradient(90deg, transparent, rgba(192,132,252,0.7), rgba(139,92,246,0.9), rgba(192,132,252,0.7), transparent)",
      }}
    />
    {[0, 1, 2].map((i) => (
      <motion.span
        key={i}
        animate={{ y: [36, -36], opacity: [0, 0.6, 0] }}
        transition={{ duration: 5 + i, repeat: Infinity, ease: "easeInOut", delay: i * 1.3 }}
        className="absolute h-1 w-1 rounded-full bg-brand-accent/70"
        style={{ left: `${30 + i * 20}%`, top: "50%" }}
      />
    ))}
  </div>
);
